import { omitBy } from "lodash";
import QueryString from 'qs';
import flowDrivers from "@/flows/driver";
import {
  preConfigWithCampaign,
  preConfigWithCartId,
  preConfigWithPartnerRefer,
} from '@/views/config/coupon/helper/pre-config';
import ComposeLoader from '@/common/compose-loader';
import { isEmptyVal } from '@/utils';
import { logger } from '@/utils/log';

export const flowTypes = {
  buyNow: 'buyNow',
  basic2pro: 'basic2pro',
  edit: 'edit',
  add2cart: 'add2cart',
  pro2biz: 'pro2biz',
  downgrade: 'downgrade',
  upgrade: 'upgrade',
  trial2paid: 'trial2paid',
  // FREE TRIAL
  add2trial: 'add_trial',
  // maybe exist edit base and add addon
  mixBuy: 'mix_buy',
  // biz to biz plus
  biz2bundle: 'biz2zone_bundle'
};

export const getDefaultFlowType = (originType) => {
  logger.info("origin flow type: ", originType);

  if (!isEmptyVal(originType)) return originType;

  const isLoggedIn = window.SB?.loggedIn;

  if(isLoggedIn) {
    logger.info("updated flow type", flowTypes.basic2pro);
    return flowTypes.basic2pro;
  }

  logger.info("updated flow type", flowTypes.buyNow);
  return flowTypes.buyNow;
};

const pageConfigLoader = () => {
  const queryObj = QueryString.parse(location.search.slice(1));
  // for campaign link with marketing coupon
  const billingConfigLoader = new ComposeLoader(window.newBillingConfig);
  billingConfigLoader.decorate("preConfigWithPartnerRefer", preConfigWithPartnerRefer);
  billingConfigLoader.decorate("preConfigWithCampaign", preConfigWithCampaign);
  billingConfigLoader.decorate("preConfigWithCartId", preConfigWithCartId);
  const newBillingConfig = billingConfigLoader.dispatch();

  const globalPageConfig = { ...omitBy(newBillingConfig.pageConfig, isEmptyVal), ...queryObj };
  // if the origin flow type is empty, should set a default flow type with login status.
  globalPageConfig.type = getDefaultFlowType(globalPageConfig.type);
  const isLoggedIn = window.SB?.loggedIn;
  if(!isLoggedIn) {
    globalPageConfig.type = flowTypes.buyNow;
  }

  const driver = flowDrivers.find((item) => item.test(globalPageConfig));

  const pageConfigState = { editConfig: {}, ...driver?.config({
    ...globalPageConfig,
    ...newBillingConfig,
  })};

  return {
    config: {
      ...globalPageConfig,
      ...newBillingConfig,
      ...pageConfigState,
    },
  };
};

const configs = pageConfigLoader();

/** @type {GlobalPageConfigBean} */
export const pageConfig = configs.config;
